// Fechas de calendario (un día, sin hora): fecha objetivo, fecha del evento,
// inicio estimado del presupuesto, vencimiento de un documento, nacimiento,
// fecha programada, trabajos de "todo el día".
//
// Nunca pasan por new Date(...).toLocaleDateString(): "2026-10-22" (o el ISO
// "2026-10-22T00:00:00.000Z" con el que se guardaron hasta oct-2026) es la
// medianoche UTC, y en Argentina (UTC-3) eso se mostraba como el día anterior.
// Acá se toma el día tal cual viene escrito.
//
// Acepta:
//   "2026-10-22"                → lo que guarda la web y lo que devuelve el
//                                 backend para las columnas `date`
//   "2026-10-22T00:00:00.000Z"  → lo guardado antes del arreglo (se toma la
//                                 parte de fecha, que es el día elegido)
//   "22/10/2026"                → lo que guarda la app en los formularios
//
// La misma lógica está en fixo-mobile/utils/fechas.ts: si se cambia acá, se
// cambia allá.

const ISO  = /^(\d{4})-(\d{2})-(\d{2})/;
const DMY  = /^(\d{2})\/(\d{2})\/(\d{4})$/;

// → { y, m, d } o null si el valor no es una fecha de calendario reconocible.
export function partesDeFecha(valor) {
  if (valor === null || valor === undefined || valor === '') return null;
  const s = String(valor).trim();
  let r = s.match(ISO);
  if (r) return { y: +r[1], m: +r[2], d: +r[3] };
  r = s.match(DMY);
  if (r) return { y: +r[3], m: +r[2], d: +r[1] };
  return null;
}

export const esFechaDeCalendario = (valor) => partesDeFecha(valor) !== null;

// "22/10/2026". Con `opciones` de Intl (p. ej. { day: '2-digit', month: 'long' })
// formatea en es-AR fijando la zona en UTC, así el día no se mueve.
// Si el valor no es una fecha reconocible, lo devuelve como texto.
export function formatearFecha(valor, opciones) {
  const p = partesDeFecha(valor);
  if (!p) return valor === null || valor === undefined ? '' : String(valor);
  if (!opciones) {
    return `${String(p.d).padStart(2, '0')}/${String(p.m).padStart(2, '0')}/${p.y}`;
  }
  return new Date(Date.UTC(p.y, p.m - 1, p.d))
    .toLocaleDateString('es-AR', { ...opciones, timeZone: 'UTC' });
}

// Date a la medianoche LOCAL de ese día, para las grillas de calendario que
// comparan con toDateString(). new Date("2026-10-22") daría la medianoche UTC
// y caería en la celda del 21.
export function fechaLocal(valor) {
  const p = partesDeFecha(valor);
  return p ? new Date(p.y, p.m - 1, p.d) : null;
}

// "2026-10-22", para guardar y para los <input type="date">.
export function fechaISO(valor) {
  const p = partesDeFecha(valor);
  if (!p) return '';
  return `${p.y}-${String(p.m).padStart(2, '0')}-${String(p.d).padStart(2, '0')}`;
}
